<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" :hide-footer="true">
            <div slot="modal-title">
                Modelo -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <modelo-form
                ref="modeloForm"
                :modelo="modelo"
                :operacao="operacao"
                @fechar="fecharModal()"
                @salvar="salvarModelo($event)"
            ></modelo-form>
        </b-modal>
    </div>
</template>

<script>
import ModeloForm from './ModeloForm'
import ModelosServicos from './ModelosServicos'

export default {
    components: {
        ModeloForm
    },

    props: {
        modelo: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'ATUALIZAÇÃO'
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            if (this.obterModelosAtualizados) {
                this.$emit('obterModelosAtualizados')
            }
        },

        salvarModelo(modelo) {
            this.$store.dispatch('addRequest')
            modelo.modeloId = this.modelo.modeloId
            ModelosServicos.atualizarModelo(modelo).then(response => {
                if (response) {
                    if (response.success) {
                        this.obterModelosAtualizados = true
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$refs.modeloForm.resetForm()
                        this.fecharModal()
                    } else {
                        this.$refs.modeloForm.setErros(response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
